import { BaseControl } from "../base-control";

class CurrencyControlCtrl extends BaseControl {
  constructor(BaseControlService, $scope) {
    'ngInject';
    super(BaseControlService, $scope);
  }
}

export default {
  bindings: {
    token: "<",
    model: "=",
    tabNumber: "<"
  },
  templateUrl: "fe-control/controls/currency-control/currency-control.component.html",
  controller: CurrencyControlCtrl
};